import { AlertCircle, CheckCircle2 } from "lucide-react";
import { cn } from "@/lib/utils";

export const FormAlert = ({ kind = "error", children, testid = "form-alert" }) => {
  if (!children) return null;
  const Icon = kind === "error" ? AlertCircle : CheckCircle2;
  return (
    <div
      role={kind === "error" ? "alert" : "status"}
      data-testid={testid}
      className={cn(
        "flex items-start gap-2 rounded-xl border px-3 py-2.5 text-sm",
        kind === "error" ? "border-destructive/40 bg-destructive/5 text-foreground" : "border-success/40 bg-success/5"
      )}
    >
      <Icon className={cn("mt-0.5 !h-4 !w-4 shrink-0", kind === "error" ? "text-destructive" : "text-success")} aria-hidden="true" />
      <span>{children}</span>
    </div>
  );
};
